module.exports = __webpack_public_path__ + "img/stats_companies.f5accdb9.svg";